import { FilterData } from "features/History/Filter/FilterData";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FilterChip, HStack } from "shared/components/Spor";

type FilterActionChipsProps = {
  filter: FilterData;
  setFilter: (filter: FilterData) => void;
};

export const FilterActionChips: FC<FilterActionChipsProps> = ({
  filter,
  setFilter,
}) => {
  const { t } = useTranslation();

  const actionChips = [
    {
      key: "train",
      checked: filter.actions.includes("train"),
      onToggle: () => setFilter(filter.updateAction("train")),
      label: t("Tog"),
    },
    {
      key: "infrastructure",
      checked: filter.actions.includes("infrastructure"),
      onToggle: () => setFilter(filter.updateAction("infrastructure")),
      label: t("Infrastruktur"),
    },
    {
      key: "station",
      checked: filter.actions.includes("station"),
      onToggle: () => setFilter(filter.updateAction("station")),
      label: t("Stasjon"),
    },
  ] as const;

  const actionChipsGlobalEvents =
    filter.countryCode === "NO"
      ? ([
          {
            key: "global",
            checked: filter.actions.includes("global"),
            onToggle: () => setFilter(filter.updateAction("global")),
            label: t("Global driftsmelding"),
          },
          {
            key: "internal",
            checked: filter.actions.includes("internal"),
            onToggle: () => setFilter(filter.updateAction("internal")),
            label: t("Intern melding"),
          },
        ] as const)
      : ([] as const);

  return (
    <HStack gap={1}>
      {[...actionChips, ...actionChipsGlobalEvents].map((chip) => (
        <FilterChip
          key={chip.key}
          size="sm"
          checked={chip.checked}
          onCheckedChange={chip.onToggle}
        >
          {chip.label}
        </FilterChip>
      ))}
    </HStack>
  );
};
